/* eslint-disable new-cap */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class JrDotDragContainer extends Phaser.GameObjects.Container {
  constructor(scene, cont) {
    super(scene);
    cont ? cont.add(this) : scene.add.existing(this);

    this.scene = scene;
    this.workingWidth = 0;
    this.workingHeight = 0;
    this.dotWidth = 50;
    this.dotHeight = 50;
    this.dots = [];
    this.isJr = true;

    this.box = ABCyaPhaser.Images.addImage(0, 0, 'AnswerBg', this).setOrigin(0, 0);

    this.initializePossiblePositions();
    let positions = this.possibleSpawnRects.slice();
    positions = ABCyaPhaser.Arrays.shuffle(positions);

    const maxDots = 10;
    let item = null;
    for (let i = 0; i < maxDots; i++) {
      item = ABCyaPhaser.Images.addImage(0, 0, 'JrCountDot', this).setScale(0);
      this.dotPop(item, 520);
      this.dots.push(item);
      item.x = positions[i].x - positions[i].width / 2;
      item.y = positions[i].y - positions[i].height / 2;
      item.setInteractive({ useHandCursor: true, draggable: true });

      item.on('dragstart', (pointer, dragX, dragY) => { this.onDotDown(pointer, dragX, dragY, this.dots[i]); });
      item.on('drag', (pointer, dragX, dragY) => { this.onDotMove(pointer, dragX, dragY, this.dots[i]); });
      item.on('dragend', () => { this.onDotUp(this.dots[i]); });
    }

    this.workingWidth = this.getBounds().width;
    this.workingHeight = this.getBounds().height;
  }

  onDotDown(pointer, dragX, dragY, target) {
    const dot = target;
    dot.setVisible(true);

    this.scene.tweens.killTweensOf(dot);
    ABCyaPhaser.Tweens.addTween(dot, 220, { scale: 1.3 }, Phaser.Math.Easing.Linear);
  };

  onDotMove(pointer, dragX, dragY, target) {
    const dot = target;
    dot.x = dragX;
    dot.y = dragY;

    if (dot.x < this.dotWidth / 2 + 12) {
      dot.x = this.dotWidth / 2 + 12;
    }
    if (dot.x > this.workingWidth - this.dotWidth / 2 - 12) {
      dot.x = this.workingWidth - this.dotWidth / 2 - 12;
    }
    if (dot.y < this.dotHeight / 2 + 12) {
      dot.y = this.dotHeight / 2 + 12;
    }
    if (dot.y > this.workingHeight - this.dotHeight / 2 - 12) {
      dot.y = this.workingHeight - this.dotHeight / 2 - 12;
    }
  };

  onDotUp(target) {
    const dot = target;
    this.scene.tweens.killTweensOf(dot);
    ABCyaPhaser.Tweens.addTween(dot, 120, { scale: 1 }, Phaser.Math.Easing.Linear);
  };

  showDotSet(num) {
    const len = this.dots.length;
    let positions = this.possibleSpawnRects.slice();
    positions = ABCyaPhaser.Arrays.shuffle(positions);
    for (let i = 0; i < len; i++) {
      if (i < num) {
        this.dots[i].setVisible(true);
        this.dots[i].x = positions[i].x - Phaser.Math.Between(1, positions[i].width / 2);
        this.dots[i].y = positions[i].y - Phaser.Math.Between(1, positions[i].height / 2);
      }
      else {
        this.dots[i].setVisible(false);
      }
      this.dots[i].scale = 0;
      this.dotPop(this.dots[i], 499);
    }
  };

  checkDevDisplay() {
    if (this.devSpawnContainer) {
      this.devSpawnContainer.removeAll();
      this.devSpawnContainer.destroy(true);
      this.devSpawnContainer = null;
    }

    this.devSpawnContainer = this.scene.add.container();
    this.add(this.devSpawnContainer);
  };

  initializePossiblePositions() {
    this.possibleSpawnRects = [];

    const boxW = 72;
    const boxH = 72;
    const spawnWidth = this.getBounds().width - 30; // this.getBounds().width - 30;
    const spawnHeight = this.getBounds().height - 30; // Decided to just hardcode, nothing below the answers
    const rowCount = Math.floor(spawnWidth / boxW);
    const columnCount = Math.floor(spawnHeight / boxH);

    const totalWidth = rowCount * boxW;
    const totalHeight = columnCount * boxH;
    let myshape = null;
    const x0 = spawnWidth - totalWidth + 12;
    const y0 = spawnHeight - totalHeight + 12;
    let x1;
    let y1;
    let sR;
    for (let i = 0; i < rowCount; i++) {
      for (let j = 0; j < columnCount; j++) {
        if (this.devSpawnContainer) {
          const color = `#${(Math.random() * 0xFFFFFF << 0).toString(16)}`;
          myshape = ABCyaPhaser.Graphics.addRect(0, 0, boxW, boxH, color, this.devSpawnContainer, { x: 0, y: 0 });
        }
        x1 = x0 + boxW * i;
        y1 = y0 + boxH * j;
        sR = { x: x1 + boxW / 2, y: y1 + boxH / 2, width: boxW, height: boxH };
        this.possibleSpawnRects.push(sR);
      }
    }
  };

  dotPop(obj, time = 320, wait = 0) {
    ABCyaPhaser.Tweens.addTween(obj, 240, { delay: wait, scaleX: 1.6, scaleY: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(obj, time, { scaleX: 1.0, scaleY: 1.0, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
    });
  };
}